import RatgeberTemplate from "@/components/RatgeberTemplate";
import { getRatgeberBySlug } from "@/data/ratgeberData";
import Footer from "@/components/Footer";

const RatgeberFieber = () => {
  const content = getRatgeberBySlug("fieber");
  
  if (!content) return null;

  return (
    <>
      <RatgeberTemplate content={content} />
      <Footer />
    </>
  );
};

export default RatgeberFieber;
